import { Grid } from 'antd';

const { useBreakpoint } = Grid;

interface ResponsiveSizes {
  fontSize: {
    xs: number;
    sm: number;
    base: number;
    lg: number;
    xlg: number;
    xl: number;
    xxl: number;
  };
  spacing: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
    xxl: number;
  };
  screens: Partial<Record<'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl', boolean>>;
}

export const useResponsiveSizes = (): ResponsiveSizes => {
  const screens = useBreakpoint();

  const isXs = screens.xs && !screens.sm;
  const isSm = screens.sm && !screens.md;
  const isMd = screens.md && !screens.lg;

  const fontSize = {
    xs: isXs ? 8 : isSm ? 9 : isMd ? 10 : 10,
    sm: isXs ? 9 : isSm ? 10 : isMd ? 11 : 11,
    base: isXs ? 11 : isSm ? 12 : isMd ? 13 : 14,
    lg: isXs ? 12 : isSm ? 13 : isMd ? 14 : 15,
    xlg: isXs ? 13 : isSm ? 14 : isMd ? 15 : 16,
    xl: isXs ? 14 : isSm ? 16 : isMd ? 18 : 20,
    xxl: isXs ? 16 : isSm ? 18 : isMd ? 20 : 24
  };

  const spacing = {
    xs: isXs ? 4 : isSm ? 6 : isMd ? 8 : 8,
    sm: isXs ? 8 : isSm ? 10 : isMd ? 12 : 12,
    md: isXs ? 12 : isSm ? 16 : isMd ? 20 : 24,
    lg: isXs ? 16 : isSm ? 20 : isMd ? 24 : 32,
    xl: isXs ? 20 : isSm ? 24 : isMd ? 32 : 40,
    xxl: isXs ? 24 : isSm ? 32 : isMd ? 40 : 48
  };

  return { fontSize, spacing, screens };
};
